import { useLocation } from "react-router-dom";
import { detectLang } from "../i18n";
import { LegalPage, Section } from "./Legal";

export function Terms() {
  const lang = detectLang(useLocation().pathname);

  if (lang === "ja") {
    return (
      <LegalPage title="利用規約" lastUpdated="2026年9月26日">
        <Section title="第1条（適用）">
          本規約は、Perusor（以下「本サービス」）の利用に関する条件を定めるものです。ユーザーは本サービスを利用することにより、本規約に同意したものとみなします。
        </Section>
        <Section title="第2条（サービスの内容）">
          本サービスは、英文を意味のかたまり（チャンク）ごとに画面の一点へ表示し、同時にネイティブ音声を再生する英語スピーキングの自習サービスです。教材は当社が用意します。
        </Section>
        <Section title="第3条（アカウント）">
          ユーザーはWorkOSを通じたGoogleアカウントで本サービスにログインします。アカウント情報の管理はユーザー自身の責任で行ってください。
        </Section>
        <Section title="第4条（有料プラン）">
          有料プラン「使い放題」の料金は月額980円（税込）です。申込み時に初回を決済し、以後は申込日を基準に毎月自動で更新・決済します。ユーザーはアプリ右上「アカウント」の「お支払い・解約の管理」からいつでも解約できます。解約後も現在の請求期間の末日まで有料プランを利用できます。日割り計算による返金を含め、支払済みの料金は返金しません。料金を改定する場合、当社は効力発生日の相当期間前までに本サービス上で通知します。無料コレクションは有料プランの契約なしで利用できます。
        </Section>
        <Section title="第5条（禁止事項）">
          以下の行為を禁止します：本サービスの逆コンパイル・リバースエンジニアリング、不正アクセス、他のユーザーへの妨害行為、教材・音声の複製・再配布、法令に違反する行為。
        </Section>
        <Section title="第6条（免責事項）">
          当社は、本サービスの利用による学習効果を保証しません。本サービスの利用により生じた損害について、当社の故意または重過失による場合を除き、当社は責任を負いません。
        </Section>
        <Section title="第7条（サービスの変更・終了）">
          当社はサービスの内容を変更し、または提供を終了することがあります。有料プランの提供を終了する場合は、事前に本サービス上で通知します。
        </Section>
        <Section title="第8条（規約の変更）">
          当社は必要に応じて本規約を変更できるものとします。変更後の規約は本ページに掲載した時点で効力を生じます。
        </Section>
        <Section title="第9条（準拠法・管轄）">
          本規約は日本法に準拠し、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </Section>
      </LegalPage>
    );
  }

  return (
    <LegalPage title="Terms of Service" lastUpdated="September 26, 2026">
      <Section title="1. Acceptance">
        By using Perusor ("the Service"), you agree to these terms. If you do not agree, do not use the Service.
      </Section>
      <Section title="2. Service Description">
        Perusor is a self-study service for English speaking. It shows English one meaning-chunk at a time at a single point on screen while native audio plays. We provide the learning material.
      </Section>
      <Section title="3. Accounts">
        You sign in with your Google account through WorkOS. You are responsible for maintaining the security of your account.
      </Section>
      <Section title="4. Paid Plan">
        The Unlimited plan costs ¥980 per month, tax included. The first payment is charged when you subscribe, and the plan renews and is charged automatically every month from that date. You can cancel anytime from "Manage billing" under Account (top right of the app); you keep access until the end of the current billing period. Fees already paid are not refunded, including on a prorated basis. We will announce any price change in the Service a reasonable time before it takes effect. Free collections are available without a subscription.
      </Section>
      <Section title="5. Prohibited Uses">
        You may not: reverse engineer the Service, attempt unauthorized access, interfere with other users, copy or redistribute the material or audio, or violate any applicable laws.
      </Section>
      <Section title="6. Disclaimer">
        We do not guarantee any learning outcome. Except in cases of our intent or gross negligence, we are not liable for damages arising from use of the Service.
      </Section>
      <Section title="7. Changes to Service">
        We may modify or discontinue the Service. We will give advance notice in the Service before ending the paid plan.
      </Section>
      <Section title="8. Changes to Terms">
        We may update these terms. Continued use after changes constitutes acceptance.
      </Section>
      <Section title="9. Governing Law">
        These terms are governed by the laws of Japan. Disputes shall be subject to the exclusive jurisdiction of the Tokyo District Court.
      </Section>
    </LegalPage>
  );
}
